import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { logout } from 'store/authCode/actions';

const useHeaderEvents = () => {
  const dispatch = useDispatch();

  // to register logout event
  useEffect(() => {
    function triggerLogout() {
      dispatch(logout());
    }

    document.addEventListener('HEADER_EVENT_LOGOUT', triggerLogout, false);
    return () => {
      document.removeEventListener('HEADER_EVENT_LOGOUT', triggerLogout, false);
    };
  }, [dispatch]);

  // to replace url to href path as the redirect url will have "?" (current platform rule)
  // only case "<url>?" after OMNI login will be replaced
  useEffect(() => {
    const pathRegex = new RegExp('\\?$');
    if (pathRegex.test(window.location.href)) {
      const href = window.location.href;
      window.history.replaceState({}, '', href.substring(0, href.length - 1));
    }
  });
};

export default useHeaderEvents;
